module.exports = __webpack_public_path__ + "img/hatchet-silver.e566235f.svg";